const ALBUM_ASSOCIATION_TYPE = 1;
const ALBUM_STUB_BODIES = new Set(["álbum", "album", "[álbum]", "[album]"]);

export function parseMessageDataJson(msg) {
  try {
    if (!msg?.dataJson) return null;
    return typeof msg.dataJson === "string" ? JSON.parse(msg.dataJson) : msg.dataJson;
  } catch {
    return null;
  }
}

export function getAlbumAssociationFromData(raw) {
  if (!raw) return null;
  const msg = raw.message || raw.event?.Message || raw;
  const candidates = [
    msg?.messageContextInfo?.messageAssociation,
    msg?.imageMessage?.contextInfo?.messageAssociation,
    msg?.videoMessage?.contextInfo?.messageAssociation,
  ];
  for (const c of candidates) {
    if (c?.parentMessageKey?.id) return c;
  }
  return null;
}

export function getAlbumParentWid(msg) {
  const raw = parseMessageDataJson(msg);
  const assoc = getAlbumAssociationFromData(raw);
  const id = assoc?.parentMessageKey?.id;
  return id != null && String(id).trim() !== "" ? String(id) : null;
}

export function getAlbumChildIndex(msg) {
  const raw = parseMessageDataJson(msg);
  const idx = getAlbumAssociationFromData(raw)?.messageIndex;
  return typeof idx === "number" && !Number.isNaN(idx) ? idx : 999;
}

export function isAlbumChildMessage(msg) {
  const raw = parseMessageDataJson(msg);
  const assoc = getAlbumAssociationFromData(raw);
  if (!assoc?.parentMessageKey?.id) return false;
  const t = assoc.associationType;
  return t === ALBUM_ASSOCIATION_TYPE || t === "MEDIA_ALBUM";
}

export function isAlbumStubMessage(msg) {
  if (!msg || msg.isDeleted) return false;
  const mt = String(msg.mediaType || "").toLowerCase();
  if (mt === "albummessage") return true;
  if (msg.mediaUrl) return false;
  const body = String(msg.body || "").trim().toLowerCase();
  return ALBUM_STUB_BODIES.has(body);
}

export function isImageMediaForAlbum(msg) {
  if (!msg || msg.isDeleted || !msg.mediaUrl) return false;
  const mt = String(msg.mediaType || "").toLowerCase();
  if (mt === "image" || mt === "imagemessage" || mt.includes("image")) return true;
  return /\.(jpe?g|png|gif|webp|bmp)(\?|#|$)/i.test(String(msg.mediaUrl));
}
